import { LatLngTuple } from "leaflet";

export function latLongToLongLat(latLng: LatLngTuple): [number, number] {
  return [latLng[1], latLng[0]];
}
